import { useSelector } from 'react-redux';
import { Button } from 'palette/Button';
import { useTranslate } from '@common/Translations';
import { getActiveFilters, getActiveFiltersByType } from '../helpers/filters';

export function FiltersPanelClearFilterBtn({ currentFilterType, onClick }) {
    const translate = useTranslate();
    const { activeFilters } = useSelector(({ filters }) => filters);
    const activeFiltersCount = activeFilters ? (currentFilterType
        ? getActiveFiltersByType(activeFilters, currentFilterType)
        : getActiveFilters(activeFilters)
    ).length : 0;
    const label = (() => {
        if (currentFilterType) {
            const labelParts = [translate('clear')];

            if (activeFiltersCount) {
                labelParts.push(`(${activeFiltersCount})`);
            }

            return labelParts.join(' ');
        }

        return translate('clear_all');
    })();

    return (
        <Button
            isExpanded
            disabled={activeFiltersCount === 0}
            label={label}
            theme="negative"
            onClick={onClick}
        />
    );
}
